
import moment from "moment-timezone"
import store from '@/store'

export function getRequestId(objectId, action) {
  const date = moment().format('DD-MM-YYYY_HH:mm:ss')
  return `${objectId}_${date}_${action}`
}

export class Ws extends WebSocket {
  constructor(url, params = {}) {
    super(url)
    Object.setPrototypeOf(this, Ws.prototype);

    params = {
      onOpen: () => {},
      onClose: () => {},
      onErrorClose: () => {},
      onError: () => {},
      onEvent: () => {},
      ...params,
    }

    this.needClose = false
    this.onopen = () => {
      if (this.needClose) {
        super.close()
      }
      params.onOpen()
      
    }

    this.callbacks = new Map()

    this.onclose = () => {
      for (const item of this.callbacks) {
        const cb = item[1]
        cb.rejectCb(new Error('connection_close'))
      }
      if (this.needClose) {
        params.onClose()
        return
      }
      /**
         * Если сокет был закрыт по другим причинам,
         * отличным от закрытия сокета в коде
         */

      if (params.onErrorClose) {
        params.onErrorClose()
      }
    }

    this.onerror = err => {
      params.onError(err)
    }

    this.onmessage = (event) => {
      if (this.needClose) {
        return
      }

      const parsedData = JSON.parse(event.data)
      const data = parsedData.data || null

      if (data) {
        if (this.callbacks.has(data.request_id)) {
          const callback = this.callbacks.get(data.request_id)
          callback.f(data)
        } else {
          params.onEvent(data)
        }
      }
    }
  }

  close() {
    if (!this.needClose) {
      this.needClose = true
      super.close()
    }
  }

  /**
   * 
   * @param {request_id: string} req 
   * @returns 
   */
  sendPromise(req) {
    if (this.readyState !== this.OPEN) {
      return new Promise(resolve => resolve())
    }
    return new Promise((resolve, reject) => {

      const callbackObj = {
        f: data => {
          this.callbacks.delete(data.request_id)
          if(data.message === undefined) {
            resolve(data)
          } else {
            store.commit('serverErrors/ADD_ERROR', data.message)
            reject(data)
          }
        },
        rejectCb: err => {
          this.callbacks.delete(req.request_id)
          reject(err)
        }
      }

      this.callbacks.set(req.request_id, callbackObj)
      
      super.send(JSON.stringify(req))
    })
  }
}

